<template>
    <div>
        <div :id="generatedId" @click="isMenu = !isMenu" style="position: relative;">
            <slot></slot>
        </div>

        <v-menu :close-on-content-click="false" offset-y full-width absolute
            v-if="isNonBg"
            v-model="isMenu"
            :attach="'#' + generatedId"
            content-class="settlement-menu"
        >
        <v-card class="white">
            <v-form v-model="isValid">
            <v-container grid-list-md fluid class="pa-2">
                <v-layout wrap align-center>
                    <v-flex class="xs4">
                        <v-autocomplete :items="countriesVisible"
                            v-model="country"
                            item-text="code" item-value="code"
                            @change="onSubmit"
                            :placeholder="val_country.code"
                            solo flat hide-details
                            :filter="(item, queryText) => (
                                item.code.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1 ||
                                item.text.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
                            )"
                        >
                            <template v-slot:item="{ item }">
                                <v-list-tile-avatar size="36" :color="item.id == 1 ? 'green lighten-3' : 'blue lighten-3'" class="white--text">
                                    {{ item.code }}
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                    <v-list-tile-title class="d-flex" style="align-items: baseline">
                                    {{ item.text }}
                                    <v-icon v-if="!item.is_allowed_orders" small color="grey"
                                        class="ml-3" style="justify-content: flex-end"
                                        :title="$t('WARNING.COUNTRY.ORDERS_DISALLOWED')"
                                    >fa-calculator</v-icon>
                                    </v-list-tile-title>
                                </v-list-tile-content>
                            </template>
                        </v-autocomplete>
                    </v-flex>
                    <template v-if="countriesItem.is_visible">
                        <v-flex class="xs8">
                            <v-text-field v-model="post_code" :label="$t('Post Code')" prepend-inner-icon="local_post_office"
                                :rules="[rules.required, rules.postcode]"
                                @keyup.enter="onSubmit"
                                :hint="`${countriesItem.text}, ${country}`" persistent-hint
                                class="pt-2"
                            ></v-text-field>
                        </v-flex>
                        <v-flex class="xs9">
                            <v-text-field v-model="settlement" :label="$t('Settlement')" prepend-inner-icon="house"
                                :rules="[rules.required]"
                                @keyup.enter="onSubmit"
                            ></v-text-field>
                        </v-flex>
                        <v-flex class="xs3 text-xs-center">
                            <v-tooltip bottom>
                                <v-btn slot="activator" icon color="success" @click="onSubmit" :disabled="!isValid"><v-icon>done</v-icon></v-btn>
                                <span>{{ $t('Apply') }}</span>
                            </v-tooltip>
                        </v-flex>
                    </template>
                    <v-flex class="xs8" v-else>
                        <div>{{ $t('WARNING.COUNTRY.NOT_VISIBLE') }}</div>
                    </v-flex>
                </v-layout>
            </v-container>
            </v-form>
        </v-card>
        </v-menu>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
    name: 'settlement-widget',
    props: ['value'],// shipment.source|target.address -> country|settlement.code|name
    data() {
        return {
            isMenu: false,
            isValid: false,
            rules: {
                required: val => !!val || this.$t('This field is required!'),
                postcode: val => !!val && (this.countriesItem.rules.length
                    ? this.countriesItem.rules.some(elem => val.length === elem.min.length && val.toString() >= elem.min.toString() && val.toString() <= elem.max.toString() && val.length === elem.max.length)
                    : true
                ) || this.$t('Invalid post code!'),
            },
            post_code: '',
            settlement: '',
            country: ''
        }
    },
    computed: {
        isNonBg() {
            return (this.value && this.value.country && this.value.country.code !== "BG");
        },
        generatedId() {
            return 'id_' + Math.random().toString().substring(2);
        },
        val_post_code() {
            return this.value && this.value.post_code;
        },
        val_country() {
            return this.value && this.value.country || {};// .code
        },
        val_settlement() {
            return this.value && this.value.settlement || {};
        },
        // Countries
        ...mapGetters(['countriesVisible']),
        countriesItem() {
            return this.countriesVisible.find(elem => elem.code === this.val_country.code) || {};
        },
    },
    watch: {
      value() {
        // console.log('watch value=', this.value);
        this.init();
        if (!this.isMenu) {// Auto open menu on value
            this.isMenu = true;
        }
      },
      isMenu() {
        if (!this.isMenu) {// Clean current model (values) on menu close; so on next open to work and show properly
            this.init();
        }
      }
    },
    methods: {
        ...mapActions(['loadCountries']),
        init() {
            if (!this.countriesItem.is_visible) {
                this.country = '';
                return;
            }

            this.country    = this.val_country.code;
            this.post_code  = this.val_post_code;
            this.settlement = this.val_settlement.name !== this.val_country.name ? this.val_settlement.name : '';
        },
        onSubmit() {
            let search = (this.countriesVisible.find(elem => elem.code === this.country) || {}).text;
            if (this.val_country.code === this.country) {
                search = ('[' + this.val_country.code + '-' + this.post_code + '] ' + this.settlement);
            }
            this.$emit('search', search);
            console.log('onSubmit search=', search);
            this.isMenu = false;
        }
    },
    created() {
        this.loadCountries();
    }
}
</script>

<style scoped>
.settlement-menu {
    margin-top: 45px;
    max-width: 100%;
}
</style>